// store/index.js
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 只管理是否需要刷新的标志
    needRefresh: false,
    paySuccess: false
  },
  mutations: {
    // 设置刷新状态
    SET_NEED_REFRESH(state, status) {
      state.needRefresh = status
    },
    // 设置支付成功状态
    SET_PAY_SUCCESS(state, status) {
      state.paySuccess = status
    }
  },
  actions: {
    // 触发刷新的动作 (可以在二级路由中 dispatch)
    triggerListRefresh({ commit }) {
      // 设置标志为 true，通知一级路由需要刷新
      commit('SET_NEED_REFRESH', true)
    }
  },
  getters: {
    needRefresh: state => state.needRefresh
  }
})